
// Returns a normalized rule object, or null if no/unrecognized offer
export function parseOffer(offerStr) {
    if (!offerStr) return null;
    const s = offerStr.trim().toLowerCase();
  
    // "buy 1 get 1 free", "buy 2 get 1 free", "buy 3 get 2 free" ...
    const bogoMatch = s.match(/buy\s*(\d+)\s*get\s*(\d+)\s*free/);
    if (bogoMatch) {
      return {
        type: "bogo",
        buy: Number(bogoMatch[1]),
        free: Number(bogoMatch[2]),
        raw: offerStr,
      };
    }
  
    // "10% extra off", "15% off", "20 % extra off"
    const percentMatch = s.match(/(\d+(\.\d+)?)\s*%/);
    if (percentMatch) {
      return {
        type: "percent",
        value: Number(percentMatch[1]),
        raw: offerStr,
      };
    }
  
    return null;
  }